import * as yup from 'yup';
import { userFeeDeductionRequestRejectFormFields } from '../../fields/formFields';

export const userFeeDeductionRequestRejectionFormSchema = yup.object({
  [userFeeDeductionRequestRejectFormFields.reviewComment]: yup.string().required(),
});
